import React, { useCallback, useEffect, useState } from 'react'
import '../Styling/landingPageSales.css';
import '../Styling/landingPageMarketplace.css';
import '../Styling/landingPageOperations.css';
import {SiAdp,SiConfluence,SiGmail,SiGoogledrive,SiGoogleforms,SiGooglesheets,SiQuickbooks,SiWhatsapp,} from 'react-icons/si';
import { PiMicrosoftOutlookLogoFill,PiMicrosoftExcelLogoFill,PiMicrosoftWordLogoFill, PiMicrosoftTeamsLogoFill   } from "react-icons/pi";
import { CgMonday } from "react-icons/cg";
import { FaDropbox, FaSalesforce, FaSlack } from "react-icons/fa";
import { ClockPlus, HandCoins, DollarSign, ChartNoAxesColumnIncreasing, MapPinned, Receipt, ContactRound, Combine, ChevronLeft as ChevLeft, ChevronRight as ChevRight, FileText, CreditCard, Link2, Wand2, ShieldAlert, GripVertical, UserCircle, ShieldCheck, Filter, Navigation, LayoutDashboard, FileSpreadsheet, Calculator, CalendarClock, FileCheck, Bell, MessageSquareText, FileBarChart, Plus, Check, CheckCircle2, Clock3, Eye, Mail, MoreVertical, Send, TrendingUp, CalendarDays, Download, MapPin, Upload, UserRound, Sparkles, AlertTriangle, ChevronDown } from 'lucide-react';
import { Modal } from '@mui/material';
import { BiLogoAdobe } from "react-icons/bi";
import { FaFilePdf } from "react-icons/fa6";



import { LandingNavigation } from '../Components/landing-navigation';
import { useIsMobile } from '../../custom-hooks/useIsMobile';
import {
    getOperationsProductByKey,
    OperationsProductItem,
    OperationsProductKey,
} from './operationsProductCatalog';
import { UserSearch, Users, ScanHeart, PhoneOutgoing, BookLock, LayoutGrid, Search, X, ChevronRight, ChevronLeft, Zap, CheckCircle, Star, Contact, ChartNoAxesCombined, Calendar, Award, LockKeyhole, ClipboardCheck, FileCheck2 } from 'lucide-react';
import { LPFooter, LPChip } from './LandingPage';
import { scrollToSection } from '../../utils/scrollToSection';
import { landingPageSeoByPath } from '../seo/LandingPageSeoConfig';
import { useLandingPageSeo } from '../seo/useLandingPageSeo';
import { WORKY_WEB_APP_PATHS } from '../../WorkyWebAppPaths';
import { navigateToContactSalesPage } from '../Components/HotIntakeLeadFormShared';
import {
    InvoiceFeatureItemProps,
    InvoiceIntegrationCardProps,
    InvoiceItem,
    InvoiceReminderMetricProps,
    InvoiceStatCardProps,
    InvoiceStatus,
    PayrollFeatureItem,
    PayrollVisualIconProps,
    TimeClockAvatarProps,
    TimeClockEmployee,
    TimeClockMetricItemProps,
    TimeClockSummaryItemProps,
    SmartMatchWorkerAvatarTone,
    SmartMatchFeatureListItem,
    SmartMatchShiftDetail,
    SmartMatchStatItem,
    SmartMatchWorkerMatch,
    WorkforceComplianceStatus,
    WorkforceMetricIconTone,
    WorkforceMetricDetailTone,
    WorkforceWorkerAvatarTone,
    WorkforceComplianceDotTone,
    WorkforceMetricItem,
    WorkforceWorkerItem,
    WorkforceComplianceItem,
    WorkforceCardHeaderProps,
    TrustVaultDocumentItem,
    TrustVaultAlertItem,
    TrustVaultWorkerItem,
} from './LandingPageProductsOperationsInterfaces';
import {
    InvoicingSelectionIllustration,
    WorkypaySelectionIllustration,
    SmartMatchSelectionIllustration,
    TimeClockSelectionIllustration,
    WorkforceSelectionIllustration,
    TrustVaultSelectionIllustration,
} from './LandingPageProductsOperationsSelectionComponents';

const bookDemoLink: string = 'https://calendly.com/worky-pro/30min';

const OPERATIONS_PAGE_CONTENT_CLASS: string = 'landing-page-products-operations';

/** Paths where operations section scroll / hash navigation is allowed. */
const OPERATIONS_SCROLL_ALLOWED_PATHS: readonly string[] = [
    WORKY_WEB_APP_PATHS.landingPageOperations,
    WORKY_WEB_APP_PATHS.landingPageOperationsSeo,
];

const isOperationsLandingPath = (pathname: string): boolean => {
    return OPERATIONS_SCROLL_ALLOWED_PATHS.some((path: string): boolean =>
        pathname === path || pathname.startsWith(path)
    );
};

const openOperationsBookDemo = (): void => {
    window.open(bookDemoLink, '_blank', 'noopener,noreferrer');
};

const shouldSkipOperationsCalendlyRouting = (button: HTMLButtonElement): boolean => {
    if (button.closest('.lpsp-side-navigation-bar')) {
        return true;
    }
    if (button.classList.contains('operations-product-modal-close')) {
        return true;
    }
    if (button.classList.contains('opm-carousel-chip')) {
        return true;
    }
    if (button.classList.contains('lpops-seo-feature-chip')) {
        return true;
    }
    if (button.classList.contains('lpops-seo-faq-button')) {
        return true;
    }
    if (button.classList.contains('lpops-seo-contact-sales')) {
        return true;
    }
    return false;
};

const handleOperationsPageButtonClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    const target: HTMLElement | null = event.target instanceof HTMLElement ? event.target : null;
    if (!target) {
        return;
    }

    const button: HTMLButtonElement | null = target.closest('button');
    if (!button || shouldSkipOperationsCalendlyRouting(button)) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();
    openOperationsBookDemo();
};

const MAKE_THE_SWITCH_BUTTON_LABEL: string = 'Make the Switch';

const OperationsMakeTheSwitchButton = ({ isMobile }: { readonly isMobile: boolean }): JSX.Element => {
    return (
        <button
            type="button"
            className={`${isMobile ? 'lpsp-hero-button-mobile' : 'lpsp-hero-button'} lpops-seo-contact-sales`}
            onClick={navigateToContactSalesPage}
        >
            {MAKE_THE_SWITCH_BUTTON_LABEL}
        </button>
    );
};


// interface OperationsHeroProps {
//     readonly isMobile: boolean;
//     readonly onOpenOperationsProductModal: (key: OperationsProductKey) => void;
// }

const OperationsHero = ({ isMobile }: {isMobile: boolean}) => {
    const MainProductsContainer = ({isMobile}: {isMobile: boolean}) => {
        return(
            <div className={`lpsp-main-products-container lpsp-operations-main-products ${isMobile ? 'is-mobile' : ''}`}>
                    <div className={isMobile ? 'lp-blog-title-mobile' : 'lp-blog-title'}>The modern operating system for healthcare staffing software &amp; home care staffing software</div>
                    <div className={isMobile ? 'lpsp-hero-subtitle-mobile' : 'lpsp-hero-subtitle'}>Worky is the industry-leading all-in-one healthcare staffing software and home care staffing software platform, trusted by the fastest-growing businesses. </div>
                    <OperationsMakeTheSwitchButton isMobile={isMobile} />
                    <div className={isMobile ? 'lpsp-main-products-container-cards-mobile lpsp-operations-product-cards-mobile' : 'lpsp-main-products-container-cards lpsp-operations-product-cards'}>
    
                        
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'invoicing', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <InvoicingSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Receipt size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Invoicing</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Automated client billing—customized to every contract</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
             
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'worky-pay', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <WorkypaySelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><HandCoins size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Worky Pay</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Flexible payroll for your contractors and employees</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'smart-match', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <SmartMatchSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Combine size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Smart Match</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>AI-driven placement that never sleeps.</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'time-clock', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <TimeClockSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><MapPinned size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Time Clock</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Digital tracking driving automated pay & billing</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'workforce', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <WorkforceSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Contact size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Workyforce</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Centralized hub for every worker in your talent pool</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'trust-vault', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <TrustVaultSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><BookLock size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Trust Vault</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Secure credential and document management</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
    
    
                    </div>
                </div>
        )
    }
    return (
        <div className='lpsp-hero-container' style={{marginTop:'40px', paddingBottom:'0px'}}>
            
            {/* 1. Background Animation Layer */}
            <div className='lpsp-background-layer'>
                <div className='lpsp-rings-center'>
                    
                    {/* Ring 1 - Smallest */}
                    <div className='lpsp-ring lpsp-ring-1'>
                        <div className='lpsp-orbiter orb-pos-1-1'><SiGooglesheets size={34} color='#0F9D58' /></div>
                        <div className='lpsp-orbiter orb-pos-1-2'><SiGoogledrive size={34} color='#4285F4' /></div>
                        <div className='lpsp-orbiter orb-pos-1-3'><SiQuickbooks size={37} color='#2CA01C' /></div>
                    </div>

                    {/* Ring 2 */}
                    <div className='lpsp-ring lpsp-ring-2'>
                        <div className='lpsp-orbiter orb-pos-2-1'><SiAdp size={37} color='#D7262D' /></div>
                        <div className='lpsp-orbiter orb-pos-2-2'><BiLogoAdobe size={34} color='#EC1C24' /></div>
                        <div className='lpsp-orbiter orb-pos-2-3'><PiMicrosoftWordLogoFill size={34} color='#2B579A' /></div>
                        <div className='lpsp-orbiter orb-pos-2-4'><SiWhatsapp size={34} color='#25D366' /></div>
                    </div>

                    {/* Ring 3 */}
                    <div className='lpsp-ring lpsp-ring-3'>
                        <div className='lpsp-orbiter orb-pos-3-1'><PiMicrosoftOutlookLogoFill size={34} color='#0078D4' /></div>
                        <div className='lpsp-orbiter orb-pos-3-2'><SiGoogleforms size={34} color='#673AB7' /></div>
                        <div className='lpsp-orbiter orb-pos-3-3'><SiGmail size={34} color='#EA4335' /></div>
                        <div className='lpsp-orbiter orb-pos-3-4'><PiMicrosoftExcelLogoFill size={34} color='#217346' /></div>
                        <div className='lpsp-orbiter orb-pos-3-5'><FaSlack size={34} color='#4A154B' /></div>
                    </div>

                        {/* Ring 4 - Largest */}
                        <div className='lpsp-ring lpsp-ring-4'>
                        <div className='lpsp-orbiter orb-pos-4-1'><SiConfluence size={34} color='#2684FF' /></div>
                        <div className='lpsp-orbiter orb-pos-4-2'><PiMicrosoftTeamsLogoFill size={34} color='#6264A7' /></div>
                        <div className='lpsp-orbiter orb-pos-4-3'><CgMonday size={34} color='#FF3D57' /></div>
                        <div className='lpsp-orbiter orb-pos-4-4'><FaFilePdf size={34} color='#FF0000' /></div>
                        <div className='lpsp-orbiter orb-pos-4-5'><FaDropbox size={34} color='#0061FF' /></div>
                        <div className='lpsp-orbiter orb-pos-4-6'><FaSalesforce size={34} color='#00A1E0' /></div>
                    </div>

                </div>
            </div>

            {/* 2. Fade Overlay Layer */}
            <div className='lpsp-fade-overlay'></div>

            {/* 3. Content Layer */}
            <div className='lpsp-hero-container-text-container'>
                <div className={isMobile ? 'lpsp-hero-title-mobile' : 'lpsp-hero-title'}>Stop Using 50+ <br />Tools for Your Business</div>
                <div className={isMobile ? 'lpsp-hero-subtitle-mobile' : 'lpsp-hero-subtitle'}>
                    Run your entire business—from shifts to payroll to invoicing—on one platform
                </div>
                <button
                    type="button"
                    className={isMobile ? 'lpsp-hero-button-mobile' : 'lpsp-hero-button'}
                    onClick={navigateToContactSalesPage}
                >
                    Start Selling
                </button>
            </div>



            {/* 4. Image/Bottom Container */}
            <div className={isMobile ? 'lpop-hero-image-container-mobile' : 'lpop-hero-image-container'}>
                <div className='lpop-hero-image-container-short'>
                    
                    
                    <div className='lpop-hero-image-container-short-inner'>
                        <div className='lpop-hero-image-container-short-inner-icon'><ClockPlus size={25} /></div>
                        <div className='lpop-hero-image-container-short-inner-text-holder'>
                            <div className='lpop-hero-image-container-short-inner-text-holder-title'>$250M in Payroll</div>
                            <div className='lpop-hero-image-container-short-inner-text-holder-subtitle'>Powered by Worky</div>
                        </div>
                    </div>
                    
                    
                    <div className='lpop-hero-image-container-short-inner'>
                        <div className='lpop-hero-image-container-short-inner-icon'><DollarSign size={25} /></div>
                        <div className='lpop-hero-image-container-short-inner-text-holder'>
                            <div className='lpop-hero-image-container-short-inner-text-holder-title'>$52,000+</div>
                            <div className='lpop-hero-image-container-short-inner-text-holder-subtitle'>Anual cost savings</div>
                        </div>
                    </div>
                    
                    
                    <div className='lpop-hero-image-container-short-inner'>
                        <div className='lpop-hero-image-container-short-inner-icon'><ChartNoAxesCombined  size={25} /></div>
                        <div className='lpop-hero-image-container-short-inner-text-holder'>
                            <div className='lpop-hero-image-container-short-inner-text-holder-title'>85%</div>
                            <div className='lpop-hero-image-container-short-inner-text-holder-subtitle'>Efficiency gain</div>
                        </div>
                    </div>

                </div>

               
                <MainProductsContainer isMobile={isMobile}/>

            </div>
        </div>
    )
}

interface OperationsProductModalProps {
    readonly open: boolean;
    readonly productKey: OperationsProductKey | null;
    readonly onClose: () => void;
}

const OperationsProductModal = ({ open, productKey, onClose }: OperationsProductModalProps) => {
    const product = productKey !== null ? getOperationsProductByKey(productKey) : undefined;
    const [activePhotoIndex, setActivePhotoIndex] = useState(0);

    useEffect(() => {
        setActivePhotoIndex(0);
    }, [productKey]);

    const photoCount = product?.photos?.length ?? 0;

    const handlePrevPhoto = () => {
        setActivePhotoIndex((prev) => (prev === 0 ? photoCount - 1 : prev - 1));
    };

    const handleNextPhoto = () => {
        setActivePhotoIndex((prev) => (prev === photoCount - 1 ? 0 : prev + 1));
    };

    return (
        <Modal open={open} onClose={onClose} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className='operations-product-modal'>
                <button className='operations-product-modal-close' onClick={onClose}><X /></button>

                <div className='opm-layout'>

                    <div className='opm-carousel'>
                        {photoCount > 0 ? (
                            <>
                                <div className='opm-carousel-viewport'>
                                    <img
                                        className='opm-carousel-image'
                                        src={product?.photos?.[activePhotoIndex]}
                                        alt={`${product?.title ?? 'Product'} screenshot ${activePhotoIndex + 1}`}
                                    />
                                </div>

                                {product?.photoChips && product.photoChips.length > 0 ? (
                                    <div className='opm-carousel-chips'>
                                        {product.photoChips.map((chip, idx) => (
                                            <button
                                                key={idx}
                                                className={`opm-carousel-chip ${idx === activePhotoIndex ? 'opm-carousel-chip-active' : ''}`}
                                                onClick={() => setActivePhotoIndex(idx)}
                                            >
                                                {chip}
                                            </button>
                                        ))}
                                    </div>
                                ) : null}
                            </>
                        ) : (
                            <div className='opm-carousel-placeholder' />
                        )}
                    </div>

                    <div className='opm-content'>
                        <div className='opm-content-header'>
                            <div className='opm-content-title'>{product?.title ?? 'Operations Product'}</div>
                            <div className='opm-content-subtitle'>{product?.subtitle ?? ''}</div>
                        </div>

                        <div className='opm-content-description'>{product?.description ?? ''}</div>

                        {product?.features && product.features.length > 0 ? (
                            <div className='opm-features'>
                                {product.features.map((feature, idx) => (
                                    <div key={idx} className='opm-feature-card'>
                                        <div className='opm-feature-card-icon'>{feature.icon}</div>
                                        <div className='opm-feature-card-text'>
                                            <div className='opm-feature-card-title'>{feature.title}</div>
                                            <div className='opm-feature-card-desc'>{feature.description}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : null}

                        <a
                            className='opm-cta-button'
                            href={product?.buttonLink ?? bookDemoLink}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {product?.buttonLabel ?? 'Learn More'}
                        </a>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const OPERATIONS_ICON_GRADIENT = 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)';

const TIME_CLOCK_EMPLOYEES: readonly TimeClockEmployee[] = [
    {
        name: 'Sarah Johnson',
        role: 'PSW',
        location: 'Sunnybrook Hospital',
        time: '9:02 AM',
        initials: 'SJ',
        positionTop: '23%',
        positionLeft: '23%',
    },
    {
        name: 'Michael Chen',
        role: 'RPN',
        location: 'North York General',
        time: '9:01 AM',
        initials: 'MC',
        positionTop: '22%',
        positionLeft: '52%',
    },
    {
        name: 'Emily Davis',
        role: 'PSW',
        location: 'Extendicare Toronto',
        time: '9:00 AM',
        initials: 'ED',
        positionTop: '58%',
        positionLeft: '67%',
    },
    {
        name: 'James Wilson',
        role: 'PSW',
        location: 'Rehab Centre',
        time: '8:59 AM',
        initials: 'JW',
        positionTop: '67%',
        positionLeft: '17%',
    },
    {
        name: 'Priya Patel',
        role: 'RPN',
        location: 'Retirement Home',
        time: '8:58 AM',
        initials: 'PP',
        positionTop: '69%',
        positionLeft: '45%',
    },
];

const TIME_CLOCK_TIMESHEET_SUMMARY: readonly (readonly [string, string])[] = [
    ['Total Hours', '186.5h'],
    ['Regular Hours', '162.5h'],
    ['Overtime Hours', '24.0h'],
    ['Break Hours', '20.0h'],
    ['Est. Payroll', '$6,842.50'],
];

const TimeClockAvatar = ({ initials, size = 'md' }: TimeClockAvatarProps): JSX.Element => (
    <div className={`op-timeclock-avatar ${size === 'sm' ? 'is-sm' : 'is-md'}`}>
        {initials}
    </div>
);

const TimeClockSummaryItem = ({
    icon,
    iconClassName,
    title,
    description,
}: TimeClockSummaryItemProps): JSX.Element => (
    <div className="op-timeclock-summary-item">
        <div className={`op-timeclock-summary-icon ${iconClassName}`}>{icon}</div>
        <div className="op-timeclock-summary-copy">
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    </div>
);

const TimeClockMetricCard = ({
    label,
    value,
    change,
    icon,
    iconClassName,
    changeClassName,
}: TimeClockMetricItemProps): JSX.Element => (
    <article className="op-timeclock-metric-card">
        <div className="op-timeclock-metric-top">
            <div>
                <p className="op-timeclock-metric-label">{label}</p>
                <p className="op-timeclock-metric-value">{value}</p>
            </div>
            <div className={`op-timeclock-metric-icon ${iconClassName}`}>{icon}</div>
        </div>
        <p className={`op-timeclock-metric-change ${changeClassName}`}>{change}</p>
    </article>
);

const TimeClockMapIllustration = (): JSX.Element => (
    <div className="op-timeclock-map">
        <svg
            className="op-timeclock-map-svg"
            viewBox="0 0 700 420"
            fill="none"
            preserveAspectRatio="none"
            aria-hidden="true"
        >
            <rect width="700" height="420" fill="#F8FAF9" />
            <path d="M-30 70C100 110 185 10 315 65C420 110 520 75 740 25" stroke="#E3E9E7" strokeWidth="18" />
            <path d="M-20 320C95 250 160 370 270 310C385 245 465 335 730 270" stroke="#E4E9E8" strokeWidth="22" />
            <path d="M80 -20C100 90 55 170 100 260C130 330 112 365 80 450" stroke="#E8ECEB" strokeWidth="14" />
            <path d="M560 -20C515 110 585 180 525 275C490 335 535 370 600 450" stroke="#E6EBE9" strokeWidth="17" />
            <path d="M180 0L230 420" stroke="#EDF1F0" strokeWidth="5" />
            <path d="M365 0L330 420" stroke="#EDF1F0" strokeWidth="5" />
            <path d="M0 170L700 130" stroke="#EDF1F0" strokeWidth="5" />
            <path d="M0 230L700 210" stroke="#EDF1F0" strokeWidth="5" />
            <path d="M420 30L510 52L550 118L505 166L410 148L385 82L420 30Z" fill="#DDF2D6" stroke="#CBE9C1" />
            <path d="M80 285L160 265L205 310L170 360L98 350L80 285Z" fill="#E3F4DD" stroke="#D2EBCB" />
            <ellipse cx="320" cy="210" rx="205" ry="145" fill="#CFEFDC" fillOpacity="0.64" stroke="#95D9B2" strokeWidth="2" />
            <circle cx="320" cy="210" r="28" fill="#0F766E" />
            <path d="M312 206L320 198L328 206V220H312V206Z" stroke="white" strokeWidth="2.2" strokeLinejoin="round" />
            <path d="M316 220V212H324V220" stroke="white" strokeWidth="2.2" />
        </svg>

        {TIME_CLOCK_EMPLOYEES.map((employee: TimeClockEmployee): JSX.Element => (
            <div
                key={employee.name}
                className="op-timeclock-map-pin"
                style={{ top: employee.positionTop, left: employee.positionLeft }}
            >
                <div className="op-timeclock-map-pin-inner">
                    <TimeClockAvatar initials={employee.initials} />
                    <span className="op-timeclock-map-pin-status" />
                </div>
            </div>
        ))}

        <div className="op-timeclock-map-zoom">
            <button type="button" className="op-timeclock-map-zoom-btn is-border">+</button>
            <button type="button" className="op-timeclock-map-zoom-btn">−</button>
        </div>
    </div>
);

const TimeClockFeatureGrid = (): JSX.Element => {
    const summaryItems: readonly TimeClockSummaryItemProps[] = [
        {
            icon: <MapPin size={24} strokeWidth={2} />,
            iconClassName: 'is-emerald',
            title: 'GPS Verified',
            description: 'Clock-ins are verified with precise GPS location and geofencing.',
        },
        {
            icon: <Eye size={24} strokeWidth={2} />,
            iconClassName: 'is-blue',
            title: 'Real-time Visibility',
            description: 'See who is working, where, and on what shift right now.',
        },
        {
            icon: <FileSpreadsheet size={24} strokeWidth={2} />,
            iconClassName: 'is-violet',
            title: 'Automated Timesheets',
            description: 'Accurate timesheets generated automatically. No manual input.',
        },
        {
            icon: <Upload size={24} strokeWidth={2} />,
            iconClassName: 'is-emerald',
            title: 'Export & Integrate',
            description: 'Export timesheets or sync with payroll and billing in one click.',
        },
    ];

    const metrics: readonly TimeClockMetricItemProps[] = [
        {
            label: 'On the Clock',
            value: '28',
            change: '+5 from yesterday',
            icon: <UserRound size={24} strokeWidth={2} />,
            iconClassName: 'is-emerald',
            changeClassName: 'is-emerald',
        },
        {
            label: 'Scheduled Today',
            value: '42',
            change: '+3 from yesterday',
            icon: <CalendarDays size={24} strokeWidth={2} />,
            iconClassName: 'is-blue',
            changeClassName: 'is-blue',
        },
        {
            label: 'Late / Missed',
            value: '3',
            change: '-2 from yesterday',
            icon: <Clock3 size={24} strokeWidth={2} />,
            iconClassName: 'is-rose',
            changeClassName: 'is-rose',
        },
        {
            label: 'Total Hours Today',
            value: '186.5',
            change: '+14.5 from yesterday',
            icon: <Clock3 size={24} strokeWidth={2} />,
            iconClassName: 'is-violet',
            changeClassName: 'is-emerald',
        },
    ];

    return (
        <section className="op-timeclock-grid" aria-label="Time Clock features">
            <aside className="op-timeclock-sidebar">
                <h2 className="op-timeclock-sidebar-title">Time Clock at a glance</h2>
                <div className="op-timeclock-summary-list">
                    {summaryItems.map((item: TimeClockSummaryItemProps): JSX.Element => (
                        <TimeClockSummaryItem
                            key={item.title}
                            icon={item.icon}
                            iconClassName={item.iconClassName}
                            title={item.title}
                            description={item.description}
                        />
                    ))}
                </div>
            </aside>

            <div className="op-timeclock-main">
                <div className="op-timeclock-metrics">
                    {metrics.map((metric: TimeClockMetricItemProps): JSX.Element => (
                        <TimeClockMetricCard
                            key={metric.label}
                            label={metric.label}
                            value={metric.value}
                            change={metric.change}
                            icon={metric.icon}
                            iconClassName={metric.iconClassName}
                            changeClassName={metric.changeClassName}
                        />
                    ))}
                </div>

                <div className="op-timeclock-attendance-card">
                    <div className="op-timeclock-attendance-header">
                        <div className="op-timeclock-attendance-title-row">
                            <h3>Live Attendance</h3>
                            <span className="op-timeclock-live-badge">
                                <span className="op-timeclock-live-dot" />
                                Live
                            </span>
                        </div>
                        <div className="op-timeclock-attendance-actions">
                            <span className="op-timeclock-attendance-count">28 employees on the clock</span>
                            <button type="button" className="op-timeclock-link-button">View all</button>
                        </div>
                    </div>

                    <div className="op-timeclock-attendance-body">
                        <TimeClockMapIllustration />

                        <div className="op-timeclock-employee-list">
                            {TIME_CLOCK_EMPLOYEES.map((employee: TimeClockEmployee, index: number): JSX.Element => (
                                <div
                                    key={employee.name}
                                    className={`op-timeclock-employee-row ${index !== TIME_CLOCK_EMPLOYEES.length - 1 ? 'has-border' : ''}`}
                                >
                                    <TimeClockAvatar initials={employee.initials} size="sm" />
                                    <div className="op-timeclock-employee-name">
                                        <p>{employee.name}</p>
                                        <span>{employee.role}</span>
                                    </div>
                                    <div className="op-timeclock-employee-location">
                                        <MapPin size={16} />
                                        <span>{employee.location}</span>
                                    </div>
                                    <div className="op-timeclock-employee-time">
                                        {employee.time}
                                        <span className="op-timeclock-employee-status-dot" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="op-timeclock-timesheet-card">
                    <div className="op-timeclock-timesheet-inner">
                        <div className="op-timeclock-timesheet-copy">
                            <h3>Today&apos;s Timesheet Summary</h3>
                            <div className="op-timeclock-timesheet-stats">
                                {TIME_CLOCK_TIMESHEET_SUMMARY.map(([label, value]: readonly [string, string], index: number): JSX.Element => (
                                    <div
                                        key={label}
                                        className={`op-timeclock-timesheet-stat ${index > 0 ? 'has-divider' : ''}`}
                                    >
                                        <p>{label}</p>
                                        <strong>{value}</strong>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <button type="button" className="op-timeclock-export-button">
                            <Download size={16} />
                            Export Timesheets
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

const TimeClockContainer = ({ isMobile }: { isMobile: boolean }): JSX.Element => {
    const clockProduct: OperationsProductItem | undefined = getOperationsProductByKey(OperationsProductKey.CLOCK);
    const clockDescription: string = clockProduct?.description ?? '';

    return (
        <div id="time-clock" className={`lpsp-inner-product-container op-timeclock-container ${isMobile ? 'is-mobile' : ''}`} style={{ marginTop: '0px' }}>
            <div className="lpsp-inner-product-container-icon-container">
                <div className="lpsp-inner-product-container-icon" style={{ background: OPERATIONS_ICON_GRADIENT }}><MapPinned size={14} /></div>
                <div className="lpsp-inner-product-container-icon-text" style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Time Clock</div>
            </div>
            <div className={isMobile ? 'lpsp-inner-product-container-title-mobile' : 'lpsp-inner-product-container-title'}>Geo-location tracking driving automated billing</div>
            <div className={isMobile ? 'lpsp-inner-product-container-subtitle-mobile' : 'lpsp-inner-product-container-subtitle'}>{clockDescription}</div>
            <OperationsMakeTheSwitchButton isMobile={isMobile} />
            <TimeClockFeatureGrid />
        </div>
    );
};

const SMART_MATCH_SHIFT_DETAILS: readonly SmartMatchShiftDetail[] = [
    { label: 'Role', value: 'Registered Nurse (RN)' },
    { label: 'Facility', value: 'Sunnybrook Hospital' },
    { label: 'Date', value: 'Mon, Jul 7, 2026' },
    { label: 'Shift', value: '07:00 AM – 07:00 PM' },
    { label: 'Priority', value: 'Urgent Fill', isPriorityBadge: true },
];

const SMART_MATCH_WORKERS: readonly SmartMatchWorkerMatch[] = [
    {
        initials: 'SJ',
        name: 'Sarah Johnson',
        role: 'RN · ICU Certified',
        rate: '$42.50/hr',
        rateLabel: 'Worker rate',
        matchScore: '98% Match',
        avatarTone: SmartMatchWorkerAvatarTone.BLUE,
    },
    {
        initials: 'MC',
        name: 'Michael Chen',
        role: 'RN · General Care',
        rate: '$39.00/hr',
        rateLabel: 'Worker rate',
        matchScore: '94% Match',
        avatarTone: SmartMatchWorkerAvatarTone.GREEN,
    },
    {
        initials: 'ED',
        name: 'Emily Davis',
        role: 'RN · Trauma Unit',
        rate: '$41.25/hr',
        rateLabel: 'Worker rate',
        matchScore: '91% Match',
        avatarTone: SmartMatchWorkerAvatarTone.PURPLE,
    },
    {
        initials: 'JW',
        name: 'James Wilson',
        role: 'RN · Med-Surg',
        rate: '$38.75/hr',
        rateLabel: 'Worker rate',
        matchScore: '87% Match',
        avatarTone: SmartMatchWorkerAvatarTone.PINK,
    },
];

const SMART_MATCH_BUILDER_FEATURES: readonly SmartMatchFeatureListItem[] = [
    { text: 'AI ranks workers by skills, availability, and proximity' },
    { text: 'One-click assignment with automatic notifications' },
    { text: 'Facility-specific rules applied to every match' },
];

const SMART_MATCH_CONFLICT_FEATURES: readonly SmartMatchFeatureListItem[] = [
    { text: 'Detects double-bookings and overtime risks instantly' },
    { text: 'Suggests qualified replacement workers automatically' },
    { text: 'Resolves conflicts before shifts go unfilled' },
];

const SMART_MATCH_CALENDAR_FEATURES: readonly SmartMatchFeatureListItem[] = [
    { text: 'Drag workers onto open shifts in seconds' },
    { text: 'Visual week view with color-coded assignments' },
    { text: 'Bulk scheduling across multiple facilities' },
];

const SMART_MATCH_STATS: readonly SmartMatchStatItem[] = [
    { value: '94%', label: 'Fill rate' },
    { value: '2.4m', label: 'Avg. match time' },
    { value: '847', label: 'Shifts matched' },
];

const SmartMatchFeatureList = ({
    items,
    listClassName,
}: {
    items: readonly SmartMatchFeatureListItem[];
    listClassName?: string;
}): JSX.Element => (
    <ul className={`op-smart-match-feature-list ${listClassName ?? ''}`.trim()}>
        {items.map((item: SmartMatchFeatureListItem): JSX.Element => (
            <li key={item.text}>
                <Check size={10} strokeWidth={3} />
                {item.text}
            </li>
        ))}
    </ul>
);

const SmartMatchWorkerAvatar = ({
    initials,
    avatarTone,
}: {
    initials: string;
    avatarTone: SmartMatchWorkerAvatarTone;
}): JSX.Element => (
    <div className={`op-smart-match-worker-avatar ${avatarTone}`}>
        {initials}
    </div>
);

const SmartMatchMatchingPanel = (): JSX.Element => (
    <div className="op-smart-match-matching-panel">
        <div className="op-smart-match-shift-details">
            <div className="op-smart-match-panel-heading">Open Shift</div>
            {SMART_MATCH_SHIFT_DETAILS.map((detail: SmartMatchShiftDetail): JSX.Element => (
                <div key={detail.label} className="op-smart-match-detail-row">
                    <span>{detail.label}</span>
                    {detail.isPriorityBadge ? (
                        <strong className="op-smart-match-priority-badge">{detail.value}</strong>
                    ) : (
                        <strong>{detail.value}</strong>
                    )}
                </div>
            ))}
        </div>

        <div className="op-smart-match-match-results">
            <div className="op-smart-match-match-results-header">
                <span>Best Matches</span>
                <button type="button">
                    <Sparkles size={10} strokeWidth={2.5} />
                    Auto-Match
                </button>
            </div>

            <div className="op-smart-match-worker-list">
                {SMART_MATCH_WORKERS.map((worker: SmartMatchWorkerMatch): JSX.Element => (
                    <div key={worker.name} className="op-smart-match-worker-row">
                        <SmartMatchWorkerAvatar initials={worker.initials} avatarTone={worker.avatarTone} />
                        <div className="op-smart-match-worker-identity">
                            <strong>{worker.name}</strong>
                            <span>{worker.role}</span>
                        </div>
                        <div className="op-smart-match-worker-rate">
                            <strong>{worker.rate}</strong>
                            <span>{worker.rateLabel}</span>
                        </div>
                        <span className="op-smart-match-match-badge">{worker.matchScore}</span>
                        <button type="button" className="op-smart-match-select-worker">Select</button>
                    </div>
                ))}
            </div>

            <button type="button" className="op-smart-match-view-more">
                View more matches
                <ChevronDown size={10} strokeWidth={2.5} />
            </button>
        </div>
    </div>
);

const SmartMatchConflictPanel = (): JSX.Element => (
    <div className="op-smart-match-conflict-panel">
        <div className="op-smart-match-conflict-alert">
            <div className="op-smart-match-alert-title">
                <AlertTriangle size={12} strokeWidth={2.5} />
                Scheduling Conflict Detected
            </div>
            <p>Sarah Johnson is already assigned to North York General from 3:00–11:00 PM on Jul 7.</p>
        </div>

        <div className="op-smart-match-resolution-card">
            <span className="op-smart-match-resolution-label">Suggested Resolution</span>
            <div className="op-smart-match-replacement-worker">
                <SmartMatchWorkerAvatar initials="MC" avatarTone={SmartMatchWorkerAvatarTone.GREEN} />
                <div>
                    <strong>Michael Chen</strong>
                    <span>RN · Available 7:00 AM – 7:00 PM</span>
                </div>
                <span className="op-smart-match-available-badge">Available</span>
            </div>
            <button type="button">Apply Resolution</button>
        </div>
    </div>
);

const SmartMatchCalendarPanel = (): JSX.Element => (
    <div className="op-smart-match-calendar-panel">
        <div className="op-smart-match-calendar-toolbar">
            <button type="button" aria-label="Previous week">
                <ChevLeft size={12} strokeWidth={2.5} />
            </button>
            <strong>Jul 7 – 9, 2026</strong>
            <button type="button" aria-label="Next week">
                <ChevRight size={12} strokeWidth={2.5} />
            </button>
            <span>Week View</span>
        </div>

        <div className="op-smart-match-calendar-grid">
            <div className="op-smart-match-calendar-day" />
            <div className="op-smart-match-calendar-day">Mon</div>
            <div className="op-smart-match-calendar-day">Tue</div>
            <div className="op-smart-match-calendar-day">Wed</div>

            <div className="op-smart-match-calendar-time">7 AM</div>
            <div>
                <div className="op-smart-match-schedule-card op-smart-match-schedule-green op-smart-match-schedule-tall">
                    <GripVertical size={8} strokeWidth={2} />
                    <div>
                        <strong>S. Johnson</strong>
                        <span>RN · 12h</span>
                    </div>
                </div>
            </div>
            <div>
                <div className="op-smart-match-schedule-card op-smart-match-schedule-blue">
                    <GripVertical size={8} strokeWidth={2} />
                    <div>
                        <strong>M. Chen</strong>
                        <span>RN · 8h</span>
                    </div>
                </div>
            </div>
            <div />

            <div className="op-smart-match-calendar-time">1 PM</div>
            <div />
            <div>
                <div className="op-smart-match-schedule-card op-smart-match-schedule-purple">
                    <GripVertical size={8} strokeWidth={2} />
                    <div>
                        <strong>E. Davis</strong>
                        <span>PSW · 8h</span>
                    </div>
                </div>
            </div>
            <div>
                <div className="op-smart-match-schedule-card op-smart-match-schedule-yellow">
                    <GripVertical size={8} strokeWidth={2} />
                    <div>
                        <strong>J. Wilson</strong>
                        <span>RN · 8h</span>
                    </div>
                </div>
            </div>

            <div className="op-smart-match-calendar-time">5 PM</div>
            <div>
                <div className="op-smart-match-schedule-card op-smart-match-schedule-blue">
                    <GripVertical size={8} strokeWidth={2} />
                    <div>
                        <strong>P. Patel</strong>
                        <span>RPN · 4h</span>
                    </div>
                </div>
            </div>
            <div />
            <div>
                <div className="op-smart-match-schedule-card op-smart-match-schedule-green">
                    <GripVertical size={8} strokeWidth={2} />
                    <div>
                        <strong>S. Ramos</strong>
                        <span>RN · 4h</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const SmartMatchFeatureGrid = (): JSX.Element => (
    <section className="op-smart-match-boxes" aria-label="Smart Match features">
        <article className="op-smart-match-feature-box op-smart-match-feature-box-large">
            <div className="op-smart-match-feature-copy">
                <div className="op-smart-match-feature-icon op-smart-match-feature-icon-teal">
                    <Users size={22} strokeWidth={2} />
                </div>
                <h2>Shift matching and schedule builder</h2>
                <p>
                    AI-powered matching ranks the best workers for every open shift — factoring in skills,
                    certifications, availability, distance, and facility preferences.
                </p>
                <SmartMatchFeatureList items={SMART_MATCH_BUILDER_FEATURES} />
            </div>
            <SmartMatchMatchingPanel />
        </article>

        <div className="op-smart-match-feature-grid">
            <article className="op-smart-match-feature-box op-smart-match-compact-feature-box">
                <div className="op-smart-match-compact-copy">
                    <div className="op-smart-match-feature-icon op-smart-match-feature-icon-purple">
                        <ShieldAlert size={20} strokeWidth={2} />
                    </div>
                    <h2>Conflict detection</h2>
                    <p>
                        Catch double-bookings, overtime risks, and certification gaps before they become
                        unfilled shifts or compliance issues.
                    </p>
                    <SmartMatchFeatureList items={SMART_MATCH_CONFLICT_FEATURES} listClassName="op-smart-match-feature-list-purple" />
                </div>
                <SmartMatchConflictPanel />
            </article>

            <article className="op-smart-match-feature-box op-smart-match-compact-feature-box">
                <div className="op-smart-match-compact-copy">
                    <div className="op-smart-match-feature-icon op-smart-match-feature-icon-yellow">
                        <CalendarDays size={20} strokeWidth={2} />
                    </div>
                    <h2>Drag &amp; drop scheduling</h2>
                    <p>
                        Build and adjust schedules visually. Drag workers onto shifts, move assignments
                        between days, and fill gaps in seconds.
                    </p>
                    <SmartMatchFeatureList items={SMART_MATCH_CALENDAR_FEATURES} listClassName="op-smart-match-feature-list-yellow" />
                </div>
                <SmartMatchCalendarPanel />
            </article>
        </div>

        <article className="op-smart-match-feature-box op-smart-match-stats-box">
            <div className="op-smart-match-stats-intro">
                <div className="op-smart-match-feature-icon op-smart-match-feature-icon-teal">
                    <Sparkles size={22} strokeWidth={2} />
                </div>
                <div>
                    <strong>Smart Match at a glance</strong>
                    <span>AI-powered scheduling metrics this week</span>
                </div>
            </div>

            {SMART_MATCH_STATS.map((stat: SmartMatchStatItem): JSX.Element => (
                <div key={stat.label} className="op-smart-match-stat-item">
                    <strong>{stat.value}</strong>
                    <span>{stat.label}</span>
                </div>
            ))}

            <div className="op-smart-match-stat-item op-smart-match-stat-item-last">
                <TrendingUp size={28} strokeWidth={2} />
                <div>
                    <strong>+18%</strong>
                    <span>Faster fill rate vs. last week</span>
                </div>
            </div>
        </article>
    </section>
);

const SmartMatchContainer = ({ isMobile }: { isMobile: boolean }): JSX.Element => {
    const smartMatchProduct: OperationsProductItem | undefined = getOperationsProductByKey(OperationsProductKey.SCHEDULE);
    const smartMatchTagline: string = smartMatchProduct?.subtitle ?? '';
    const smartMatchDescription: string = smartMatchProduct?.description ?? '';

    return (
        <div id="smart-match" className={`lpsp-inner-product-container op-smart-match-container ${isMobile ? 'is-mobile' : ''}`} style={{ marginTop: '0px' }}>
            <div className="lpsp-inner-product-container-icon-container">
                <div className="lpsp-inner-product-container-icon" style={{ background: OPERATIONS_ICON_GRADIENT }}><Combine size={14} /></div>
                <div className="lpsp-inner-product-container-icon-text" style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Smart Match</div>
            </div>
            <div className={isMobile ? 'lpsp-inner-product-container-title-mobile' : 'lpsp-inner-product-container-title'}>{smartMatchTagline}</div>
            <div className={isMobile ? 'lpsp-inner-product-container-subtitle-mobile' : 'lpsp-inner-product-container-subtitle'}>{smartMatchDescription}</div>
            <OperationsMakeTheSwitchButton isMobile={isMobile} />
            <SmartMatchFeatureGrid />
        </div>
    );
};

const PayrollCheckIcon = (): JSX.Element => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8.3 12.2 10.7 14.6 15.9 9.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const PayrollDownloadIcon = (): JSX.Element => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3v11m0 0 4-4m-4 4-4-4M5 18v2h14v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const PayrollDocumentIcon = (): JSX.Element => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7 3h7l4 4v14H7V3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M14 3v5h5M10 12h5M10 16h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const PayrollClockIcon = (): JSX.Element => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 7.5v5l3.4 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const PayStubVisual = (): JSX.Element => (
    <div className="payroll-ui-card payroll-stub">
        <div className="payroll-stub-header">
            <span className="payroll-stub-title">Pay Stub</span>
            <span className="payroll-paid-badge">PAID</span>
        </div>
        <div className="payroll-ui-divider" />
        <div className="payroll-label">Employee Name</div>
        <div className="payroll-amount">$1,250.00</div>
        <div className="payroll-net-pay">Net Pay</div>
        <div className="payroll-line-row">
            <span className="payroll-line payroll-line--long" />
            <span className="payroll-line payroll-line--short" />
        </div>
        <div className="payroll-line-row">
            <span className="payroll-line payroll-line--short" />
            <span className="payroll-line payroll-line--medium" />
            <span className="payroll-line payroll-line--short" />
        </div>
        <div className="payroll-success-check">
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12.5 9.3 17 19 7" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    </div>
);

const TIMESHEET_ROWS: readonly (readonly [string, string])[] = [
    ['Mon', '8.00'],
    ['Tue', '8.50'],
    ['Wed', '9.00'],
    ['Thu', '8.00'],
    ['Fri', '7.50'],
];

const TimesheetVisual = ({ icon }: PayrollVisualIconProps): JSX.Element => (
    <div className="payroll-timesheet-wrap">
        {icon}
        <div className="payroll-ui-card payroll-timesheet">
            <div className="payroll-timesheet-top">
                <div className="payroll-avatar" />
                <div className="payroll-timesheet-lines">
                    <span className="payroll-line payroll-line--long" />
                    <span className="payroll-line payroll-line--medium" />
                </div>
            </div>
            <table>
                <tbody>
                    {TIMESHEET_ROWS.map(([day, hours]: readonly [string, string]): JSX.Element => (
                        <tr key={day}>
                            <td>{day}</td>
                            <td>{hours}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="payroll-timesheet-total">
                <span>Total</span>
                <span>41.00 hrs</span>
            </div>
        </div>
    </div>
);

const PAY_STUBS: readonly (readonly [string, string])[] = [
    ['May 24, 2026', '$1,250.00'],
    ['May 10, 2026', '$1,160.00'],
    ['Apr 26, 2026', '$1,220.00'],
];

const PayStubPhoneVisual = ({ icon }: PayrollVisualIconProps): JSX.Element => (
    <div className="payroll-phone-wrap">
        {icon}
        <div className="payroll-phone">
            <div className="payroll-phone-title">My Pay Stubs</div>
            {PAY_STUBS.map(([date, amount]: readonly [string, string]): JSX.Element => (
                <div className="payroll-phone-item" key={date}>
                    <div>
                        <div className="payroll-phone-date">{date}</div>
                        <div className="payroll-phone-amount">{amount}</div>
                    </div>
                    <div className="payroll-phone-download">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M12 4v10m0 0 4-4m-4 4-4-4M6 19h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

const PayrollReportVisual = ({ icon }: PayrollVisualIconProps): JSX.Element => (
    <div className="payroll-report-wrap">
        {icon}
        <div className="payroll-ui-card payroll-report">
            <div className="payroll-report-header">
                <span className="payroll-report-title">Payroll Summary</span>
            </div>
            <div className="payroll-report-body">
                <div className="payroll-donut" />
                <div className="payroll-report-legend">
                    <div className="payroll-report-row">
                        <span className="payroll-dot payroll-dot--blue" />
                        <span>Gross Pay</span>
                        <strong>$24,500</strong>
                    </div>
                    <div className="payroll-report-row">
                        <span className="payroll-dot payroll-dot--purple" />
                        <span>Deductions</span>
                        <strong>$5,250</strong>
                    </div>
                    <div className="payroll-report-row">
                        <span className="payroll-dot payroll-dot--teal" />
                        <span>Net Pay</span>
                        <strong>$19,250</strong>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const PayrollFeatureGrid = (): JSX.Element => {
    const features: readonly PayrollFeatureItem[] = [
        {
            title: 'Payroll run and pay stubs',
            description: 'Run payroll in minutes and generate professional pay stubs automatically.',
            bullets: ['One-click payroll runs', 'Detailed pay stubs', 'Employee earnings breakdown'],
            visual: <PayStubVisual />,
        },
        {
            title: 'Auto-calculate from timesheets',
            description: 'Sync approved timesheets and let Worky handle payroll calculations for you.',
            bullets: ['Timesheet integration', 'Overtime and deductions', 'Accurate and error-free'],
            visual: (
                <TimesheetVisual
                    icon={
                        <div className="payroll-floating-icon payroll-floating-icon--purple">
                            <PayrollClockIcon />
                        </div>
                    }
                />
            ),
        },
        {
            title: 'Digital pay stubs',
            description: 'Employees can securely access, download and review their pay stubs anywhere.',
            bullets: ['Secure employee portal', 'Download and share', 'Year-to-date summaries'],
            visual: (
                <PayStubPhoneVisual
                    icon={
                        <div className="payroll-floating-icon payroll-floating-icon--purple payroll-floating-icon--phone">
                            <PayrollDocumentIcon />
                        </div>
                    }
                />
            ),
        },
        {
            title: 'Easy reporting and exports',
            description: 'Export payroll reports and summaries for accounting, reconciliation and compliance.',
            bullets: ['Payroll summary reports', 'Tax and deduction reports', 'Export to CSV or PDF'],
            visual: (
                <PayrollReportVisual
                    icon={
                        <div className="payroll-floating-icon payroll-floating-icon--green payroll-floating-icon--report">
                            <PayrollDownloadIcon />
                        </div>
                    }
                />
            ),
        },
    ];

    return (
        <section className="payroll-feature-grid" aria-label="Payroll features">
            {features.map((feature: PayrollFeatureItem): JSX.Element => (
                <article className="payroll-feature-card" key={feature.title}>
                    <div className="payroll-feature-copy">
                        <h3>{feature.title}</h3>
                        <p>{feature.description}</p>
                        <ul>
                            {feature.bullets.map((bullet: string): JSX.Element => (
                                <li key={bullet}>
                                    <span className="payroll-check">
                                        <PayrollCheckIcon />
                                    </span>
                                    <span>{bullet}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="payroll-feature-visual">{feature.visual}</div>
                </article>
            ))}
        </section>
    );
};

const WorkyPayContainer = ({ isMobile }: { isMobile: boolean }): JSX.Element => {
    const payProduct: OperationsProductItem | undefined = getOperationsProductByKey(OperationsProductKey.PAY);
    const paySubtitle: string = payProduct?.subtitle ?? '';

    return (
        <div id="worky-pay" className={`lpsp-inner-product-container op-payroll-container ${isMobile ? 'is-mobile' : ''}`} style={{ marginTop: '0px' }}>
            <div className="lpsp-inner-product-container-icon-container">
                <div className="lpsp-inner-product-container-icon" style={{ background: OPERATIONS_ICON_GRADIENT }}><HandCoins size={14} /></div>
                <div className="lpsp-inner-product-container-icon-text" style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Worky Pay</div>
            </div>
            <div className={isMobile ? 'lpsp-inner-product-container-title-mobile' : 'lpsp-inner-product-container-title'}>Payroll and payment processing</div>
            <div className={isMobile ? 'lpsp-inner-product-container-subtitle-mobile' : 'lpsp-inner-product-container-subtitle'}>{paySubtitle}</div>
            <OperationsMakeTheSwitchButton isMobile={isMobile} />
            <PayrollFeatureGrid />
        </div>
    );
};

const WORKFORCE_METRICS: readonly WorkforceMetricItem[] = [
    {
        label: 'Total Workers',
        value: '1,248',
        detail: '↑ 8.5% vs last month',
        icon: <Users size={20} strokeWidth={2} />,
        iconTone: WorkforceMetricIconTone.CYAN,
        detailTone: WorkforceMetricDetailTone.POSITIVE,
    },
    {
        label: 'Expiring Docs',
        value: '324',
        detail: '↑ 12 this week',
        icon: <FileText size={20} strokeWidth={2} />,
        iconTone: WorkforceMetricIconTone.BLUE,
        detailTone: WorkforceMetricDetailTone.WARNING,
    },
    {
        label: 'Compliance Rate',
        value: '98%',
        detail: '↑ 2% vs last month',
        icon: <ShieldCheck size={20} strokeWidth={2} />,
        iconTone: WorkforceMetricIconTone.VIOLET,
        detailTone: WorkforceMetricDetailTone.POSITIVE,
    },
    {
        label: 'Certifications',
        value: '2,156',
        detail: 'Active',
        icon: <Award size={20} strokeWidth={2} />,
        iconTone: WorkforceMetricIconTone.AMBER,
        detailTone: WorkforceMetricDetailTone.NEUTRAL,
    },
    {
        label: 'Onboarding',
        value: '186',
        detail: 'In Progress',
        icon: <CheckCircle2 size={20} strokeWidth={2} />,
        iconTone: WorkforceMetricIconTone.EMERALD,
        detailTone: WorkforceMetricDetailTone.NEUTRAL,
    },
    {
        label: 'Avg. Rating',
        value: '4.7/5',
        detail: 'Performance',
        icon: <Star size={20} strokeWidth={2} />,
        iconTone: WorkforceMetricIconTone.PINK,
        detailTone: WorkforceMetricDetailTone.NEUTRAL,
    },
];

const WORKFORCE_WORKERS: readonly WorkforceWorkerItem[] = [
    {
        initials: 'SJ',
        name: 'Sarah Johnson',
        role: 'Registered Nurse',
        certifications: 12,
        status: WorkforceComplianceStatus.COMPLIANT,
        avatarTone: WorkforceWorkerAvatarTone.BLUE,
    },
    {
        initials: 'MC',
        name: 'Michael Chen',
        role: 'Personal Support Worker',
        certifications: 8,
        status: WorkforceComplianceStatus.COMPLIANT,
        avatarTone: WorkforceWorkerAvatarTone.ORANGE,
    },
    {
        initials: 'PP',
        name: 'Priya Patel',
        role: 'Registered Practical Nurse',
        certifications: 10,
        status: WorkforceComplianceStatus.EXPIRING_SOON,
        avatarTone: WorkforceWorkerAvatarTone.VIOLET,
    },
    {
        initials: 'DT',
        name: 'David Thompson',
        role: 'Healthcare Assistant',
        certifications: 6,
        status: WorkforceComplianceStatus.COMPLIANT,
        avatarTone: WorkforceWorkerAvatarTone.EMERALD,
    },
    {
        initials: 'ED',
        name: 'Emily Davis',
        role: 'Nurse Practitioner',
        certifications: 14,
        status: WorkforceComplianceStatus.COMPLIANT,
        avatarTone: WorkforceWorkerAvatarTone.PINK,
    },
];

const WORKFORCE_COMPLIANCE_ITEMS: readonly WorkforceComplianceItem[] = [
    { label: 'Compliant', value: '1,223', dotTone: WorkforceComplianceDotTone.EMERALD },
    { label: 'Expiring Soon', value: '324', dotTone: WorkforceComplianceDotTone.AMBER },
    { label: 'Expired', value: '12', dotTone: WorkforceComplianceDotTone.RED },
    { label: 'Pending', value: '45', dotTone: WorkforceComplianceDotTone.SLATE },
];

const WORKFORCE_FILTER_TAGS: readonly string[] = ['RPN', 'Toronto', 'Compliant'];

const WORKFORCE_FILTER_DROPDOWNS: readonly string[] = ['All Roles', 'All Locations', 'All Status'];

const WorkforceCardHeader = ({
    icon,
    title,
    action,
}: WorkforceCardHeaderProps): JSX.Element => (
    <div className="op-workforce-card-header">
        <div className="op-workforce-card-header-title">
            {icon}
            <h3>{title}</h3>
        </div>
        {action ? (
            <button type="button" className="op-workforce-card-header-action">
                {action}
            </button>
        ) : null}
    </div>
);

const WorkforceWorkerAvatar = ({
    initials,
    avatarTone,
}: {
    initials: string;
    avatarTone: WorkforceWorkerAvatarTone;
}): JSX.Element => (
    <div className={`op-workforce-worker-avatar ${avatarTone}`}>
        {initials}
    </div>
);

const WorkforceFeatureGrid = (): JSX.Element => (
    <section className="op-workforce-grid" aria-label="Workforce features">
        <article className="op-workforce-card">
            <WorkforceCardHeader
                icon={<Users size={20} strokeWidth={2} />}
                title="Workforce overview"
            />
            <div className="op-workforce-metrics-grid">
                {WORKFORCE_METRICS.map((metric: WorkforceMetricItem): JSX.Element => (
                    <div key={metric.label} className="op-workforce-metric-cell">
                        <div className={`op-workforce-metric-icon ${metric.iconTone}`}>
                            {metric.icon}
                        </div>
                        <p className="op-workforce-metric-value">{metric.value}</p>
                        <p className="op-workforce-metric-label">{metric.label}</p>
                        <p className={`op-workforce-metric-detail ${metric.detailTone}`}>
                            {metric.detail}
                        </p>
                    </div>
                ))}
            </div>
        </article>

        <article className="op-workforce-card">
            <WorkforceCardHeader
                icon={<Award size={20} strokeWidth={2} />}
                title="Worker profiles and certifications"
                action="View all"
            />
            <div className="op-workforce-worker-list">
                {WORKFORCE_WORKERS.map((worker: WorkforceWorkerItem): JSX.Element => (
                    <div key={worker.name} className="op-workforce-worker-row">
                        <div className="op-workforce-worker-identity">
                            <WorkforceWorkerAvatar initials={worker.initials} avatarTone={worker.avatarTone} />
                            <div className="op-workforce-worker-copy">
                                <p>{worker.name}</p>
                                <span>{worker.role}</span>
                            </div>
                        </div>
                        <div className="op-workforce-worker-certifications">
                            <p>{worker.certifications}</p>
                            <span>Certifications</span>
                        </div>
                        <span
                            className={`op-workforce-status-badge ${
                                worker.status === WorkforceComplianceStatus.COMPLIANT
                                    ? 'is-compliant'
                                    : 'is-expiring'
                            }`}
                        >
                            {worker.status}
                        </span>
                    </div>
                ))}
            </div>
        </article>

        <article className="op-workforce-card">
            <WorkforceCardHeader
                icon={<Search size={20} strokeWidth={2} />}
                title="Search and filter"
            />
            <div className="op-workforce-search-panel">
                <label className="op-workforce-search-input">
                    <Search size={16} strokeWidth={2} />
                    <input type="text" placeholder="Search workers..." readOnly />
                </label>

                <div className="op-workforce-filter-grid">
                    {WORKFORCE_FILTER_DROPDOWNS.map((label: string): JSX.Element => (
                        <button key={label} type="button" className="op-workforce-filter-dropdown">
                            {label}
                            <ChevronDown size={16} strokeWidth={2} />
                        </button>
                    ))}
                    <button type="button" className="op-workforce-filter-button">
                        <Filter size={16} strokeWidth={2} />
                        Filters
                    </button>
                </div>

                <div className="op-workforce-filter-tags">
                    {WORKFORCE_FILTER_TAGS.map((tag: string): JSX.Element => (
                        <button key={tag} type="button" className="op-workforce-filter-tag">
                            {tag}
                            <span aria-hidden="true">×</span>
                        </button>
                    ))}
                    <button type="button" className="op-workforce-clear-filters">
                        Clear all
                    </button>
                </div>
            </div>
        </article>

        <article className="op-workforce-card">
            <WorkforceCardHeader
                icon={<ShieldCheck size={20} strokeWidth={2} />}
                title="Compliance tracking"
                action="View report"
            />
            <div className="op-workforce-compliance-panel">
                <div className="op-workforce-compliance-chart-wrap">
                    <div
                        className="op-workforce-compliance-chart"
                        style={{
                            background:
                                'conic-gradient(#10b981 0deg 352.8deg, #f59e0b 352.8deg 356deg, #ef4444 356deg 358deg, #e2e8f0 358deg 360deg)',
                        }}
                    >
                        <div className="op-workforce-compliance-chart-inner">
                            <span className="op-workforce-compliance-chart-value">98%</span>
                            <span className="op-workforce-compliance-chart-label">Compliant</span>
                        </div>
                    </div>
                </div>

                <div className="op-workforce-compliance-legend">
                    {WORKFORCE_COMPLIANCE_ITEMS.map((item: WorkforceComplianceItem): JSX.Element => (
                        <div key={item.label} className="op-workforce-compliance-row">
                            <div className="op-workforce-compliance-row-label">
                                <span className={`op-workforce-compliance-dot ${item.dotTone}`} />
                                <span>{item.label}</span>
                            </div>
                            <strong>{item.value}</strong>
                        </div>
                    ))}
                </div>
            </div>
        </article>
    </section>
);

const WorkforceContainer = ({ isMobile }: { isMobile: boolean }): JSX.Element => {
    return (
        <div id="workforce" className={`lpsp-inner-product-container op-workforce-container ${isMobile ? 'is-mobile' : ''}`} style={{ marginTop: '0px' }}>
            <div className="lpsp-inner-product-container-icon-container">
                <div className="lpsp-inner-product-container-icon" style={{ background: OPERATIONS_ICON_GRADIENT }}><Contact size={14} /></div>
                <div className="lpsp-inner-product-container-icon-text" style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Workforce</div>
            </div>
            <div className={isMobile ? 'lpsp-inner-product-container-title-mobile' : 'lpsp-inner-product-container-title'}>Workforce management platform</div>
            <div className={isMobile ? 'lpsp-inner-product-container-subtitle-mobile' : 'lpsp-inner-product-container-subtitle'}>A centralized hub for every worker — onboarding documents, certifications, and performance history. Full visibility into your talent pool.</div>
            <OperationsMakeTheSwitchButton isMobile={isMobile} />
            <WorkforceFeatureGrid />
        </div>
    );
};

const TRUST_VAULT_DOCUMENTS: readonly TrustVaultDocumentItem[] = [
    { name: 'RN License', type: 'License' },
    { name: 'CPR Certificate', type: 'Certificate' },
    { name: 'Police Check', type: 'Background Check' },
    { name: 'Immunization Record', type: 'Record' },
];

const TRUST_VAULT_ALERTS: readonly TrustVaultAlertItem[] = [
    { name: 'RN License', expiry: 'Expires in 15 days' },
    { name: 'CPR Certificate', expiry: 'Expires in 30 days' },
    { name: 'Police Check', expiry: 'Expires in 45 days' },
];

const TRUST_VAULT_WORKERS: readonly TrustVaultWorkerItem[] = [
    { initials: 'SJ', name: 'Sarah Johnson', document: 'RN License' },
    { initials: 'MC', name: 'Michael Chen', document: 'CPR Certificate' },
    { initials: 'JM', name: 'Jessica Miller', document: 'Police Check' },
];

const TrustVaultFeatureGrid = (): JSX.Element => (
    <section className="trust-vault-grid" aria-label="Trust Vault features">
        <article className="trust-card trust-card--blue">
            <div className="trust-card__content">
                <div className="trust-card__copy">
                    <div className="trust-icon trust-icon--blue">
                        <LockKeyhole size={23} strokeWidth={2.2} />
                    </div>

                    <h3>Secure document vault and credential storage</h3>

                    <p>
                        Store worker documents, licenses, and certifications in one
                        encrypted vault with secure, role-based access.
                    </p>
                </div>

                <div className="trust-preview document-preview">
                    <div className="preview-header">
                        <div className="preview-heading">
                            <LockKeyhole size={13} />
                            <span>Document Vault</span>
                        </div>

                        <span className="preview-count">24 files</span>
                    </div>

                    <div className="preview-list">
                        {TRUST_VAULT_DOCUMENTS.map((document: TrustVaultDocumentItem): JSX.Element => (
                            <div className="document-row" key={document.name}>
                                <div className="document-row__icon">
                                    <FileText size={14} />
                                </div>

                                <div className="document-row__details">
                                    <strong>{document.name}</strong>
                                    <span>{document.type}</span>
                                </div>

                                <span className="status-badge">Verified</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="floating-badge floating-badge--blue">
                    <ShieldCheck size={29} fill="currentColor" />
                </div>
            </div>
        </article>

        <article className="trust-card trust-card--green">
            <div className="trust-card__content">
                <div className="trust-card__copy">
                    <div className="trust-icon trust-icon--green">
                        <Bell size={23} strokeWidth={2.2} />
                    </div>

                    <h3>Expiry alerts and verification workflows</h3>

                    <p>
                        Automatically flag expiring credentials and guide your team
                        through consistent verification workflows.
                    </p>
                </div>

                <div className="trust-preview alert-preview">
                    <div className="preview-header">
                        <div>
                            <span className="preview-eyebrow">Upcoming</span>
                            <h4>Expiry Alerts</h4>
                        </div>

                        <span className="notification-count">3</span>
                    </div>

                    <div className="preview-list">
                        {TRUST_VAULT_ALERTS.map((alert: TrustVaultAlertItem): JSX.Element => (
                            <div className="alert-row" key={alert.name}>
                                <div>
                                    <strong>{alert.name}</strong>
                                    <span>{alert.expiry}</span>
                                </div>

                                <Bell size={14} />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="floating-badge floating-badge--green">
                    <Bell size={27} fill="currentColor" />
                </div>
            </div>
        </article>

        <article className="trust-card trust-card--purple">
            <div className="trust-card__content">
                <div className="trust-card__copy">
                    <div className="trust-icon trust-icon--purple">
                        <ClipboardCheck size={23} strokeWidth={2.2} />
                    </div>

                    <h3>Audit-ready compliance tracking</h3>

                    <p>
                        Monitor credential requirements across your workforce and
                        generate clear compliance reports whenever needed.
                    </p>
                </div>

                <div className="trust-preview compliance-preview">
                    <div className="preview-header">
                        <div>
                            <span className="preview-eyebrow">Workforce status</span>
                            <h4>Compliance Overview</h4>
                        </div>

                        <FileCheck2 size={18} />
                    </div>

                    <div className="compliance-body">
                        <div className="compliance-ring">
                            <div className="compliance-ring__inner">
                                <strong>98%</strong>
                                <span>Compliant</span>
                            </div>
                        </div>

                        <div className="compliance-stats">
                            <div>
                                <span className="stat-dot stat-dot--green" />
                                <span>Compliant</span>
                                <strong>98%</strong>
                            </div>

                            <div>
                                <span className="stat-dot stat-dot--orange" />
                                <span>Expiring soon</span>
                                <strong>2%</strong>
                            </div>

                            <div>
                                <span className="stat-dot stat-dot--red" />
                                <span>Expired</span>
                                <strong>0%</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="floating-badge floating-badge--purple">
                    <CheckCircle2 size={29} fill="currentColor" />
                </div>
            </div>
        </article>

        <article className="trust-card trust-card--cyan">
            <div className="trust-card__content">
                <div className="trust-card__copy">
                    <div className="trust-icon trust-icon--cyan">
                        <Users size={23} strokeWidth={2.2} />
                    </div>

                    <h3>Instant access when you need it</h3>

                    <p>
                        Find any worker credential instantly by person, document type,
                        verification status, or expiry date.
                    </p>
                </div>

                <div className="trust-preview search-preview">
                    <div className="preview-header">
                        <div>
                            <span className="preview-eyebrow">Credential finder</span>
                            <h4>Quick Search</h4>
                        </div>

                        <Search size={18} />
                    </div>

                    <div className="search-field">
                        <Search size={14} />
                        <span>Search documents...</span>
                    </div>

                    <div className="preview-list">
                        {TRUST_VAULT_WORKERS.map((worker: TrustVaultWorkerItem): JSX.Element => (
                            <div className="worker-row" key={worker.name}>
                                <div className="worker-avatar">{worker.initials}</div>

                                <div className="worker-row__details">
                                    <strong>{worker.name}</strong>
                                    <span>{worker.document}</span>
                                </div>

                                <span className="status-badge">Verified</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="floating-badge floating-badge--cyan">
                    <Search size={28} strokeWidth={2.5} />
                </div>
            </div>
        </article>
    </section>
);

const TrustVaultContainer = ({ isMobile }: { isMobile: boolean }): JSX.Element => {
    const trustVaultProduct: OperationsProductItem | undefined = getOperationsProductByKey(OperationsProductKey.TRUST_VAULT);
    const trustVaultSubtitle: string = trustVaultProduct?.subtitle ?? '';
    const trustVaultDescription: string = trustVaultProduct?.description ?? '';

    return (
        <div id="trust-vault" className={`lpsp-inner-product-container op-trust-vault-container ${isMobile ? 'is-mobile' : ''}`} style={{ marginTop: '0px' }}>
            <div className="lpsp-inner-product-container-icon-container">
                <div className="lpsp-inner-product-container-icon" style={{ background: OPERATIONS_ICON_GRADIENT }}><BookLock size={14} /></div>
                <div className="lpsp-inner-product-container-icon-text" style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Trust Vault</div>
            </div>
            <div className={isMobile ? 'lpsp-inner-product-container-title-mobile' : 'lpsp-inner-product-container-title'}>{trustVaultSubtitle}</div>
            <div className={isMobile ? 'lpsp-inner-product-container-subtitle-mobile' : 'lpsp-inner-product-container-subtitle'}>{trustVaultDescription}</div>
            <OperationsMakeTheSwitchButton isMobile={isMobile} />
            <TrustVaultFeatureGrid />
        </div>
    );
};

const INVOICES: readonly InvoiceItem[] = [
    {
        number: 'INV-2026-128',
        client: 'CareWell Nursing',
        amount: '$12,450.00',
        issueDate: 'Jul 8, 2026',
        dueDate: 'Jul 22, 2026',
        status: InvoiceStatus.PAID,
    },
    {
        number: 'INV-2026-127',
        client: 'BrightLife Home Care',
        amount: '$8,750.00',
        issueDate: 'Jul 7, 2026',
        dueDate: 'Jul 21, 2026',
        status: InvoiceStatus.PENDING,
    },
    {
        number: 'INV-2026-126',
        client: 'FirstStep Health',
        amount: '$6,200.00',
        issueDate: 'Jul 6, 2026',
        dueDate: 'Jul 20, 2026',
        status: InvoiceStatus.OVERDUE,
    },
    {
        number: 'INV-2026-125',
        client: 'TotalCare Solutions',
        amount: '$9,300.00',
        issueDate: 'Jul 5, 2026',
        dueDate: 'Jul 19, 2026',
        status: InvoiceStatus.PAID,
    },
];

const INVOICE_STATUS_CLASS_NAMES: Readonly<Record<InvoiceStatus, string>> = {
    [InvoiceStatus.PAID]: 'is-paid',
    [InvoiceStatus.PENDING]: 'is-pending',
    [InvoiceStatus.OVERDUE]: 'is-overdue',
};

const InvoiceStatusBadge = ({ status }: { readonly status: InvoiceStatus }): JSX.Element => (
    <span className={`op-invoice-status ${INVOICE_STATUS_CLASS_NAMES[status]}`}>
        {status}
    </span>
);

const InvoiceFeatureItem = ({
    icon,
    iconClassName,
    title,
    description,
}: InvoiceFeatureItemProps): JSX.Element => (
    <div className="op-invoice-feature-item">
        <div className={`op-invoice-feature-icon ${iconClassName}`}>{icon}</div>
        <div className="op-invoice-feature-copy">
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    </div>
);

const InvoiceStatCard = ({
    label,
    value,
    icon,
    iconClassName,
}: InvoiceStatCardProps): JSX.Element => (
    <div className="op-invoice-stat-card">
        <div>
            <p>{label}</p>
            <strong>{value}</strong>
        </div>
        <div className={`op-invoice-stat-icon ${iconClassName}`}>{icon}</div>
    </div>
);

const InvoiceIntegrationCard = ({
    logo,
    logoClassName,
    name,
}: InvoiceIntegrationCardProps): JSX.Element => (
    <div className="op-invoice-integration-card">
        <div className={`op-invoice-integration-logo ${logoClassName}`}>{logo}</div>
        <div className="op-invoice-integration-copy">
            <strong>{name}</strong>
            <span>Connected <Check size={14} /></span>
        </div>
    </div>
);

const InvoiceReminderMetric = ({
    icon,
    value,
    label,
}: InvoiceReminderMetricProps): JSX.Element => (
    <div className="op-invoice-reminder-metric">
        <div className="op-invoice-reminder-icon">{icon}</div>
        <div>
            <strong>{value}</strong>
            <span>{label}</span>
        </div>
    </div>
);

const InvoicingContainer = ({ isMobile }: { isMobile: boolean }): JSX.Element => {
    const invoicesProduct: OperationsProductItem | undefined = getOperationsProductByKey(OperationsProductKey.INVOICES);
    const invoicesSubtitle: string = invoicesProduct?.subtitle ?? '';

    return (
        <div id="invoicing" className={`lpsp-inner-product-container op-invoicing-container ${isMobile ? 'is-mobile' : ''}`} style={{ marginTop: '0px' }}>
            <div className="lpsp-inner-product-container-icon-container">
                <div className="lpsp-inner-product-container-icon" style={{ background: OPERATIONS_ICON_GRADIENT }}><Receipt size={14} /></div>
                <div className="lpsp-inner-product-container-icon-text" style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Invoicing</div>
            </div>
            <div className={isMobile ? 'lpsp-inner-product-container-title-mobile' : 'lpsp-inner-product-container-title'}>Invoice creation and tracking</div>
            <div className={isMobile ? 'lpsp-inner-product-container-subtitle-mobile' : 'lpsp-inner-product-container-subtitle'}>{invoicesSubtitle}</div>
            <OperationsMakeTheSwitchButton isMobile={isMobile} />
            <section className="op-invoice-grid">
                <article className="op-invoice-card op-invoice-overview">
                    <div className="op-invoice-card-heading">
                        <h2>Operations at a glance</h2>
                        <p>Everything your team needs to create, manage and track invoices in one place.</p>
                    </div>
                    <div className="op-invoice-feature-list">
                        <InvoiceFeatureItem
                            icon={<FileText size={20} />}
                            iconClassName="is-emerald"
                            title="Automated invoicing"
                            description="Create accurate invoices using approved hours, rates and client contract rules."
                        />
                        <InvoiceFeatureItem
                            icon={<TrendingUp size={20} />}
                            iconClassName="is-blue"
                            title="Real-time tracking"
                            description="Track invoice status, payment activity and outstanding balances."
                        />
                        <InvoiceFeatureItem
                            icon={<Bell size={20} />}
                            iconClassName="is-violet"
                            title="Smart reminders"
                            description="Automatically follow up on upcoming and overdue payments."
                        />
                        <InvoiceFeatureItem
                            icon={<Link2 size={20} />}
                            iconClassName="is-indigo"
                            title="Accounting integrations"
                            description="Keep your invoicing records synchronized with your accounting software."
                        />
                    </div>
                </article>

                <article className="op-invoice-card op-invoice-dashboard">
                    <div className="op-invoice-dashboard-header">
                        <div className="op-invoice-card-heading">
                            <h2>Invoices</h2>
                            <p>Monitor invoice activity across your operations.</p>
                        </div>
                        <button type="button" className="op-invoice-primary-button">
                            <Plus size={16} />
                            Create invoice
                        </button>
                    </div>

                    <div className="op-invoice-stats">
                        <InvoiceStatCard label="Total invoices" value="128" icon={<FileText size={20} />} iconClassName="is-blue" />
                        <InvoiceStatCard label="Paid" value="92" icon={<CheckCircle2 size={20} />} iconClassName="is-emerald" />
                        <InvoiceStatCard label="Pending" value="24" icon={<Clock3 size={20} />} iconClassName="is-amber" />
                        <InvoiceStatCard label="Overdue" value="12" icon={<Clock3 size={20} />} iconClassName="is-red" />
                    </div>

                    <div className="op-invoice-table-scroll">
                        <table className="op-invoice-table">
                            <thead>
                                <tr>
                                    <th>Invoice #</th>
                                    <th>Client</th>
                                    <th>Amount</th>
                                    <th>Issue date</th>
                                    <th>Due date</th>
                                    <th>Status</th>
                                    <th className="is-actions">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {INVOICES.map((invoice: InvoiceItem): JSX.Element => (
                                    <tr key={invoice.number}>
                                        <td className="is-invoice-number">{invoice.number}</td>
                                        <td>{invoice.client}</td>
                                        <td className="is-amount">{invoice.amount}</td>
                                        <td className="is-muted">{invoice.issueDate}</td>
                                        <td className="is-muted">{invoice.dueDate}</td>
                                        <td><InvoiceStatusBadge status={invoice.status} /></td>
                                        <td>
                                            <div className="op-invoice-actions">
                                                <button type="button" aria-label={`View ${invoice.number}`}><Eye size={16} /></button>
                                                <button type="button" aria-label={`More options for ${invoice.number}`}><MoreVertical size={16} /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <button type="button" className="op-invoice-text-button is-full-width">
                        View all invoices <span aria-hidden="true">→</span>
                    </button>
                </article>

                <article className="op-invoice-card op-invoice-secondary-card">
                    <div className="op-invoice-card-heading">
                        <h2>Integrations</h2>
                        <p>Connect your accounting tools and keep your workflow synchronized.</p>
                    </div>
                    <div className="op-invoice-integrations">
                        <InvoiceIntegrationCard logo="qb" logoClassName="is-quickbooks" name="QuickBooks" />
                        <InvoiceIntegrationCard logo="xero" logoClassName="is-xero" name="Xero" />
                        <button type="button" className="op-invoice-add-integration">
                            <Plus size={20} />
                            Add integration
                        </button>
                    </div>
                </article>

                <article className="op-invoice-card op-invoice-secondary-card">
                    <div className="op-invoice-card-heading">
                        <h2>Send &amp; remind</h2>
                        <p>Follow up on outstanding invoices and keep collections moving.</p>
                    </div>
                    <div className="op-invoice-reminder-metrics">
                        <InvoiceReminderMetric icon={<Mail size={20} />} value="24" label="Not sent" />
                        <InvoiceReminderMetric icon={<Bell size={20} />} value="18" label="Reminders sent" />
                        <InvoiceReminderMetric icon={<Send size={20} />} value="6" label="Scheduled" />
                    </div>
                    <div className="op-invoice-reminder-footer">
                        <button type="button" className="op-invoice-text-button">
                            View all reminders <span aria-hidden="true">→</span>
                        </button>
                    </div>
                </article>
            </section>
        </div>
    );
};

const OPERATIONS_SECTION_IDS = ['invoicing', 'worky-pay', 'time-clock', 'smart-match', 'workforce', 'trust-vault'] as const;

const SideNavigationBar = ({isMobile, isVisible, activeSection}: {isMobile: boolean; isVisible: boolean; activeSection: string | null}) => {
    return (
        <div className={`lpsp-side-navigation-bar is-operations ${isMobile ? 'is-mobile' : ''} ${isVisible ? 'is-visible' : ''}`}>
            <button
                className={`lpsp-side-navigation-bar-item ${activeSection === 'invoicing' ? 'is-active' : ''}`}
                onClick={() => scrollToSection({ sectionId: 'invoicing', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
            >
                <span className='lpsp-side-navigation-bar-icon'><Receipt size={18} /></span>
                <span className='lpsp-side-navigation-bar-text'>Invoicing</span>
            </button>

            <button
                className={`lpsp-side-navigation-bar-item ${activeSection === 'worky-pay' ? 'is-active' : ''}`}
                onClick={() => scrollToSection({ sectionId: 'worky-pay', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
            >
                <span className='lpsp-side-navigation-bar-icon'><HandCoins size={18} /></span>
                <span className='lpsp-side-navigation-bar-text'>Worky Pay</span>
            </button>

            <button
                className={`lpsp-side-navigation-bar-item ${activeSection === 'time-clock' ? 'is-active' : ''}`}
                onClick={() => scrollToSection({ sectionId: 'time-clock', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
            >
                <span className='lpsp-side-navigation-bar-icon'><MapPinned size={18} /></span>
                <span className='lpsp-side-navigation-bar-text'>Time Clock</span>
            </button>

            <button
                className={`lpsp-side-navigation-bar-item ${activeSection === 'smart-match' ? 'is-active' : ''}`}
                onClick={() => scrollToSection({ sectionId: 'smart-match', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
            >
                <span className='lpsp-side-navigation-bar-icon'><Combine size={18} /></span>
                <span className='lpsp-side-navigation-bar-text'>Smart Match</span>
            </button>

            <button
                className={`lpsp-side-navigation-bar-item ${activeSection === 'workforce' ? 'is-active' : ''}`}
                onClick={() => scrollToSection({ sectionId: 'workforce', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
            >
                <span className='lpsp-side-navigation-bar-icon'><Contact size={18} /></span>
                <span className='lpsp-side-navigation-bar-text'>Workforce</span>
            </button>

            <button
                className={`lpsp-side-navigation-bar-item ${activeSection === 'trust-vault' ? 'is-active' : ''}`}
                onClick={() => scrollToSection({ sectionId: 'trust-vault', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
            >
                <span className='lpsp-side-navigation-bar-icon'><BookLock size={18} /></span>
                <span className='lpsp-side-navigation-bar-text'>Trust Vault</span>
            </button>

            <button
                className='lpsp-side-navigation-bar-item is-contact'
                onClick={() => document.getElementById('lp-footer')?.scrollIntoView({ behavior: 'smooth' })}
            >
                <span className='lpsp-side-navigation-bar-icon'><PhoneOutgoing size={16} /></span>
                <span className='lpsp-side-navigation-bar-text'>Contact Us</span>
            </button>

            <button
                className='lpsp-side-navigation-bar-item is-demo'
                onClick={openOperationsBookDemo}
            >
                <span className='lpsp-side-navigation-bar-icon'><Star size={18} /></span>
                <span className='lpsp-side-navigation-bar-text'>Book Demo</span>
            </button>
        </div>
    );
};



const LandingPageProductsOperations = () => {
    const isMobile = useIsMobile();
    useLandingPageSeo(landingPageSeoByPath[WORKY_WEB_APP_PATHS.landingPageOperations]);
    const [isSideNavVisible, setIsSideNavVisible] = useState(false);
    const [activeSection, setActiveSection] = useState<string | null>(null);
    const [isOperationsProductModalOpen, setIsOperationsProductModalOpen] = useState(false);
    const [selectedOperationsProductKey, setSelectedOperationsProductKey] = useState<OperationsProductKey | null>(null);

    const handleOperationsHashScroll = useCallback(() => {
        if (!isOperationsLandingPath(window.location.pathname)) return;

        const sectionId = window.location.hash?.replace('#', '');
        if (!sectionId) return;

        const supportedSections = new Set<string>(OPERATIONS_SECTION_IDS);
        if (!supportedSections.has(sectionId)) return;

        setTimeout(() => {
            scrollToSection({
                sectionId,
                allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS],
                offset: isMobile ? 70 : 80,
                behavior: 'smooth',
            });
        }, 100);
    }, [isMobile]);

    useEffect(() => {
        handleOperationsHashScroll();
        window.addEventListener('hashchange', handleOperationsHashScroll);
        return () => window.removeEventListener('hashchange', handleOperationsHashScroll);
    }, [handleOperationsHashScroll]);

    useEffect(() => {
        // if (isMobile) return;

        let rafId: number | null = null;

        const updateVisibility = () => {
            const sectionEls = OPERATIONS_SECTION_IDS.map(id => document.getElementById(id));
            const firstEl = sectionEls[0];
            if (!firstEl) return;

            const tops = sectionEls.map(el => el ? el.getBoundingClientRect().top + window.pageYOffset : Number.POSITIVE_INFINITY);
            const firstTop = tops[0];

            const shouldShow = window.pageYOffset >= firstTop - 400;
            setIsSideNavVisible(prev => (prev === shouldShow ? prev : shouldShow));

            if (!shouldShow) {
                setActiveSection(prev => (prev === null ? prev : null));
                return;
            }

            const y = window.pageYOffset + 220;
            let nextActive: string | null = null;
            for (let i = OPERATIONS_SECTION_IDS.length - 1; i >= 0; i--) {
                if (y >= tops[i] - 10) {
                    nextActive = OPERATIONS_SECTION_IDS[i];
                    break;
                }
            }
            setActiveSection(prev => (prev === nextActive ? prev : nextActive));
        };

        const onScroll = () => {
            if (rafId) return;
            rafId = window.requestAnimationFrame(() => {
                rafId = null;
                updateVisibility();
            });
        };

        updateVisibility();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', updateVisibility);
        return () => {
            if (rafId) window.cancelAnimationFrame(rafId);
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', updateVisibility);
        };
    }, [isMobile]);

    return (
        <>
            <LandingNavigation/>
            <div
                className={OPERATIONS_PAGE_CONTENT_CLASS}
                onClickCapture={handleOperationsPageButtonClick}
            >
                <OperationsHero isMobile={isMobile} />
                <InvoicingContainer isMobile={isMobile} />
                <WorkyPayContainer isMobile={isMobile} />
                <TimeClockContainer isMobile={isMobile} />
                <SmartMatchContainer isMobile={isMobile} />
                <WorkforceContainer isMobile={isMobile} />
                <TrustVaultContainer isMobile={isMobile} />
                <OperationsProductModal
                    open={isOperationsProductModalOpen}
                    productKey={selectedOperationsProductKey}
                    onClose={() => {
                        setIsOperationsProductModalOpen(false);
                        setSelectedOperationsProductKey(null);
                    }}
                />
                <SideNavigationBar isMobile={isMobile} isVisible={isSideNavVisible} activeSection={activeSection}/>
                <LPFooter isMobile={isMobile} />
            </div>
        </>
    );
}


export {
    LandingPageProductsOperations,
    OperationsHero,
    InvoicingContainer,
    WorkyPayContainer,
    TimeClockContainer,
    SmartMatchContainer,
    WorkforceContainer,
    TrustVaultContainer,
    SideNavigationBar,
    OperationsProductModal,
    OPERATIONS_SECTION_IDS,
    OPERATIONS_PAGE_CONTENT_CLASS,
    OPERATIONS_SCROLL_ALLOWED_PATHS,
    isOperationsLandingPath,
    handleOperationsPageButtonClick,
    openOperationsBookDemo,
    OperationsMakeTheSwitchButton,
};